import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d204210a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"fit-content","margin-top":"6px","margin-left":"15px"} }
const _hoisted_2 = {
  t: "1761103845699",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  style: {"width":"18px","height":"18px"},
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7883",
  width: "200",
  height: "200"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M512 0C229.677176 0 0 229.677176 0 512S229.677176 1024 512 1024 1024 794.322824 1024 512 794.322824 0 512 0z m0 963.764706C262.866824 963.764706 60.235294 761.133176 60.235294 512S262.866824 60.235294 512 60.235294 963.764706 262.866824 963.764706 512 761.133176 963.764706 512 963.764706z m30.117647-218.714353h58.970353v60.235294H422.912v-60.235294H481.882353v-266.24h-56.982588v-60.235294H542.117647v326.475294zM432.790588 300.333176a59.331765 59.331765 0 1 1 118.66353-0.060235 59.331765 59.331765 0 0 1-118.66353 0.060235z",
  "p-id": "7884",
  fill: "var(--cm-color-text-regular)"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import { reactive, ref, computed } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  ActionType,
  ActionTypeValuesByKeys,
  DateType,
  FormActionType,
  FormSize,
  FormSizeType,
  FormType,
  ObjectFormItem,
} from '@/components/cmForm/types'
import { PolicyCommonService } from '@/views/dashboard/policy/policy-common.service'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import GroupTreeSelector from '../../_components/group-tree-selector/group-tree-selector.vue'
import { computerInfoCols } from '../../data-safe/ransomware-protection/types/ransomware-incident'
import { useParseTime } from '@/hooks'
import { formatTimeStamp } from '@/utils/time'
import { formatMapToOptions } from '@/utils/tool'
import PolicySelect from '@/views/dashboard/_components/policy-select/policy-select.vue'
import { PolicyType } from '@/views/dashboard/_enum/policy-type'
import { useRoute } from 'vue-router'
import dayjs from 'dayjs'
import { TableOpt } from '@/components/cmTable/types'
import { IpLogRow, RequestParams, TerminalNetIpLimitListService } from './service'
import RawDataDrawer from '@/views/dashboard/_components/raw-data-drawer/raw-data-drawer.vue'
import { ActionState } from './types'
import {
  getActionStateLabelMap,
  getDirectionStateLabelMap,
  getProtocolStateLabelMap,
} from './ip-address-blocking-labels'
import { PermissionFe, ServicePermissionService } from '@/services/service-permission.service'

type ExcludeRequestParams = Exclude<keyof RequestParams, 'limit' | 'page' | 'device_id' | 'date'>

export default /*#__PURE__*/_defineComponent({
  __name: 'ip-address-blocking-log',
  setup(__props) {

const { t, locale } = useI18n()
const injector = useReflectiveInjector([TerminalNetIpLimitListService, PolicyCommonService])
const terminalNetIpLimitListService = injector.get(TerminalNetIpLimitListService)
const api = terminalNetIpLimitListService.getTerminalNetIpLimitList.bind(terminalNetIpLimitListService)
const exportSensitiveFileSendApi = terminalNetIpLimitListService.getTerminalNetIpLimitExport.bind(terminalNetIpLimitListService)
const route = useRoute()
const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const formType = ref(FormActionType.Other)
const formSize: FormSizeType = FormSize.Small
const defaultPolicyId = route.query.policy_id as string || undefined
const defaultDate = [dayjs().subtract(30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
const [start_time, end_time] = useParseTime(defaultDate)
const queryForm = reactive<Partial<RequestParams> & { dateRange?: any[] }>({
  strategy_id: defaultPolicyId,
  dateRange: defaultDate,
  start_time,
  end_time,
  direction: null,
  action: null
})
const queryFormColumns = computed<ObjectFormItem<RequestParams & { dateRange?: any[] }, ExcludeRequestParams | 'dateRange'>>(() => {
  const _localeDep = locale.value
  return {
  strategy_id: {
    colOpt: { style: 'flex: 0 0 130px' },
    slot: true,
    get label() { return t('ipAddressBlocking.triggerPolicy') },
    hiddenAllLabel: true,
    outSearchFiledFlag: true,
    events: {
      change: () => { void refreshList() },
    },
  },
  group_id: {
    colOpt: { style:'flex:0 0 150px' },
    slot: true,
    get label() { return t('ipAddressBlocking.group') },
    hiddenAllLabel: true,
    outSearchFiledFlag: true,
    events: {
      change: () => { void refreshList() },
    },
  },
  dateRange: {
    colOpt: { style: 'flex: 0 0 280px' },
    get label() { return t('ipAddressBlocking.dateRange') },
    type: FormType.Date,
    dateType: DateType.DateRange,
    events: {
      change: (val) => {
        const [start, end] = useParseTime(val)
        queryForm.start_time = start
        queryForm.end_time = end
        void refreshList()
      },
    },
    dateOpt: {
      'value-format': 'YYYY-MM-DD',
      get 'start-placeholder'() { return t('ipAddressBlocking.startPlaceholder') },
      get 'end-placeholder'() { return t('ipAddressBlocking.endPlaceholder') },
      clearable: false,
    },
  },
  direction: {
    colOpt: { span: 12 },
    get label() { return t('ipAddressBlocking.interceptDirection') },
    type: FormType.Select,
    selectOpt: {
      clearable: true,
    },
    dictData: formatMapToOptions(getDirectionStateLabelMap(t), true),
  },
  action: {
    colOpt: { span: 12 },
    get label() { return t('ipAddressBlocking.executeAction') },
    type: FormType.Select,
    selectOpt: {
      clearable: true,
    },
    dictData: formatMapToOptions(getActionStateLabelMap(t), true).filter(item => item.value !== ActionState.just_record),
  },
}
})


async function handleSearch(value: string) {
  queryForm.key_word = value
  await refreshList()
}

async function handleQuery(form: any) {
  Object.assign(queryForm, form)
  if (form.dateRange) {
    const [start, end] = useParseTime(form.dateRange)
    queryForm.start_time = start
    queryForm.end_time = end
  }
  await refreshList()
}

function handleQueryChange() {
  void refreshList()
}

function handleReset() {
  queryForm.strategy_id = defaultPolicyId
  queryForm.group_id = undefined
  queryForm.dateRange = defaultDate
  const [start, end] = useParseTime(defaultDate)
  queryForm.start_time = start
  queryForm.end_time = end
  queryForm.direction = null
  queryForm.action = null
  queryForm.key_word = ''
  void refreshList()
}
const isShowRawData = ref(false)
const currentRow = ref<any>({})

const tableActOpt = computed(() => {
  const _localeDep = locale.value
  return {
  columnOpt: { label: t('ipAddressBlocking.operation'), width: 120, align: 'left' as const, fixed: 'right' as const },
  actionButtons: (row: IpLogRow) => [
    { name: t('ipAddressBlocking.dataSource'), type: 'rawData', opt: { size: FormSize.Small, text: true, type: 'text' } },
  ],
  }
})

const tableOpt = computed<TableOpt>(() => {
  const _localeDep = locale.value
  const directionLabels = getDirectionStateLabelMap(t)
  const protocolLabels = getProtocolStateLabelMap(t)
  const actionLabels = getActionStateLabelMap(t)
  return {
  bodyStyle: 'background: var(--cm-color-card-bg);padding:0 16px 16px',
  containerOpt: { style: 'padding: 0;background: var(--cm-color-card-bg)' },
  height: '100%',
  path: 'list',
  showActionBar: false,
  showForm: false,
  showRightToolbar: false,
  rowKey: 'device_id',
  selection: false,
  columns: [
    {
      label: t('bootOptimize.interceptTime'),
      prop: 'intercept_time',
      minWidth: 150,
      formatter: (_row, val) => formatTimeStamp(val, 'YYYY-MM-DD HH:mm')
    },
    {
      label: t('ipAddressBlocking.policyName'),
      prop: 'strategy_name',
      columnOpt: { minWidth: 120, },
      formatter: (_row, val) => val || '--',
      showOverflow: true,
    },
    ...computerInfoCols(true, true, t),
    {
      label: t('ipAddressBlocking.operateProcess'),
      prop: 'process_name', showOverflow: true,
      minWidth: 180, formatter: (_row, value) => value || '--'
    },
    {
      label: t('ipAddressBlocking.interceptDirection'),
      prop: 'direction', formatter: (_row, value) => directionLabels[value] || '--',
      minWidth: 130,
    }, {
      label: t('ipAddressBlocking.protocol'),
      prop: 'protocol',
      minWidth: 100, formatter: (_row, value) => protocolLabels[value] || '--'
    }, {
      label: t('ipAddressBlocking.localIpPort'),
      prop: 'local_port', formatter: (_row, value) => `${_row.local_ip}:${value}`,
      minWidth: 170,
    }, {
      label: t('ipAddressBlocking.remoteIpPort'),
      prop: 'remote_ip',
      minWidth: 160, formatter: (_row, value) => `${value}:${_row.remote_port}`
    }, {
      label: t('ipAddressBlocking.executeAction'),
      prop: 'action',
      minWidth: 190, formatter: (_row, value) => actionLabels[value] || '--'
    }, {
      label: t('ipAddressBlocking.interceptCount'),
      prop: 'num',
      minWidth: 100, formatter: (_row, value) => value || 0
    },
  ],
  }
})

const handleAction = ({
  type,
  rowItem,
}: {
  type: ActionTypeValuesByKeys
  rowItem?: IpLogRow
  other?: any[]
}) => {
  const types: { [p: string]: () => void } = {
    [ActionType.Download]: () => {
      exportSensitiveFileSendApi(0, queryForm, t('ipAddressBlocking.exportLogName'))
    },
    rawData: () => {
      currentRow.value = rowItem
      isShowRawData.value = true
    },
  }
  types[type]?.()
}
const updateGroupId = (groupId) => {
  queryForm.group_id = groupId
  handleQueryChange()
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CmTable, {
      tableOpt: tableOpt.value,
      modelValue: queryForm,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryForm) = $event)),
      tableActOpt: tableActOpt.value,
      "has-permission": true,
      api: _unref(api),
      "first-loading": false,
      ref_key: "tableRef",
      ref: tableRef,
      pageOption: {
    style: 'padding-bottom: 16px',
    pageNumName: 'page',
    pageSizeName: 'limit',
  },
      onHandleAction: handleAction,
      class: "cm-ui-shadow-container"
    }, {
      header: _withCtx(({ rowData }) => [
        _createVNode(SearchFilterBar, {
          style: {"padding":"16px 0 0","background-color":"var(--cm-color-card-bg)"},
          modelValue: queryForm,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm) = $event)),
          "form-columns": queryFormColumns.value,
          "show-search": true,
          "search-placeholder": _ctx.$t('ipAddressBlocking.searchPlaceholder'),
          "popover-threshold": 2,
          onSearch: handleSearch,
          onQuery: handleQuery,
          onReset: handleReset
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_el_button, {
              size: _unref(formSize),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAction({ type: _unref(ActionType).Download }))),
              type: "primary",
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('ipAddressBlocking.exportRecord')), 1)
              ]),
              _: 1
            }, 8, ["size"]),
            _createVNode(_component_router_link, {
              class: "cm-ui-ml10",
              to: "/dashboard/ip-address-blocking"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('ipAddressBlocking.viewIpAccessPolicy')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_tooltip, {
              content: _ctx.$t('ipAddressBlocking.interceptLogTip'),
              placement: "top",
              effect: "light"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
                ])
              ]),
              _: 1
            }, 8, ["content"])
          ]),
          strategy_id: _withCtx(() => [
            _createVNode(PolicySelect, {
              width: "100%",
              size: "small",
              modelValue: queryForm.strategy_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.strategy_id) = $event)),
              "strategy-type": _unref(PolicyType).ip_address_blocking,
              onChange: handleQueryChange
            }, null, 8, ["modelValue", "strategy-type"])
          ]),
          group_id: _withCtx(() => [
            _createVNode(GroupTreeSelector, {
              "terminal-type": [_unref(TerminalType).windows, _unref(TerminalType).windowsServer],
              onSelected: updateGroupId
            }, null, 8, ["terminal-type"])
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "search-placeholder"])
      ]),
      _: 1
    }, 8, ["tableOpt", "modelValue", "tableActOpt", "api"]),
    _createVNode(RawDataDrawer, {
      modelValue: isShowRawData.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isShowRawData).value = $event)),
      "raw-data": currentRow.value
    }, null, 8, ["modelValue", "raw-data"])
  ], 64))
}
}

})